import { Link } from "react-router-dom";
import Panel from "../components/common/Panel";
import { t } from "../i18n/messages";
import { buildPath } from "../utils/routing";

export default function NotFoundPage({ locale = "zh-Hans" }) {
  return (
    <Panel title={t(locale, "notFoundTitle")} description={t(locale, "notFoundDesc")}>
      <Link className="btn btn-primary" to={buildPath(locale, "")}>
        {t(locale, "notFoundBackHome")}
      </Link>
    </Panel>
  );
}
